export const codeInputStyles = {
    width: '59px',
    height: '50px',
    border: '1px solid #E6E6E6',
    marginRight: '24px',
    borderRadius: '4px',
    fontSize: '22px',
    padding: '0',
    textAlign: 'center',
    fontWeight: '700'
};

export const inputStyles = {
    width: '320px',
    height: '50px',
    border: 'none',
    backgroundColor: '#F4F4F4',
};

export const dropdownStyles = {
    border: 'none',
    borderRight: '1px solid #FFFFFF',
    backgroundColor: '#F4F4F4',
};

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6Lc2jqctAAAAAHYMukKgGgbSyWrh1QKf_zYTTErj';
export const CODE_INPUT_FIELDS_AMOUNT = 4;
export const CALL_AUTH_TYPE = 'call';
export const SMS_AUTH_TYPE = 'sms';
export const PLUS_SIGN = '+';
export const DEFAULT_TIME_TO_NEXT_CALL = 59;
export const TIME_BEFORE_SMS_AVAILABLE = 30;
export const COUNTRIES_LIST = ['ru', 'am', 'az', 'by', 'ge', 'kg', 'kz', 'md', 'tj', 'uz'];
export const COUNTRIES_PARAMS = {
    LOCALIZATION: {
        ru: 'Россия',
        am: 'Армения',
        kz: 'Казахстан',
        az: 'Азербайджан',
        by: 'Беларусь',
        ge: 'Грузия',
        kg: 'Киргизия',
        md: 'Молдова',
        tj: 'Таджикистан',
        uz: 'Узбекистан',
    },
    PHONE_LENGTHS: {
        ru: 11,
        am: 11,
        kz: 11,
        az: 12,
        by: 12,
        ge: 12,
        kg: 12,
        md: 11,
        tj: 12,
        uz: 12,
    },
    PHONE_MASKS: {
        kz: '(...) ...-..-..',
        az: '(..) ...-..-..',
        by: '(..) ...-..-..',
        ge: '(..) ...-..-..',
        tj: '(..) ...-..-..',
        uz: '(..) ...-..-..',
        kg: '(..) ...-..-..',
        md: '(..) ..-..-..',
        am: '(..) ..-..-..',
    }
}